<template>
  <v-card :class="`contact-information-card ${firstHeader ? '' : 'mt-4'}`" outlined>
    <v-card-text class="pb-0">
      <v-row class="mb-0 pb-0">
        <v-col class="pb-0 pt-1" cols="12" md="12">
          <span style="font-size: 17px;">{{ getLabel }}: <strong>{{ item.fullname || '-' }}</strong> </span>
        </v-col>
        <v-col class="pb-0 pt-1" cols="12" md="12">
          <span style="display: flex;" class="pt-0">
            {{ $t('Įgaliojimo registro pranešimai bus pateikti:') }}
            <el-tooltip :indexKey="item.amn_id" tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Įgaliojimo registro pranešimai bus pateikti" subTitle></el-tooltip>
          </span>
        </v-col>
         <v-col class="pb-2 pt-1" cols="12" md="12">
        <v-divider></v-divider>
        <template v-if="showSMSInfo">
          <div class="py-2">
            <span class="info-sms-msg">{{showSMSInfo}}</span>
          </div>
          <v-divider></v-divider>
        </template>
        </v-col>
        <v-col class="pb-0" cols="4" md="4">
          <el-checkbox
            style="margin-top: 3px"
            label="SMS žinute"
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. SMS žinute"
            :tooltipIndexKey= item.amn_id
            v-model="item.sms_enabled"
          >
          </el-checkbox>
        </v-col>
        <v-col class="pb-0" cols="8" md="8">
          <v-row no-gutters>
            <v-col cols="2">
               <el-text-field
                v-if="showPhoneNumber"
                :required="phoneNumberReq"
                v-model="item.phone_number_prepend"
                prependField
                :validateKey="getKeyPhoneNumber"
              />
            </v-col>
           <v-col cols="10">
              <el-text-field
                style="border-radius: 0px 4px 4px 0px;"
                v-if="showPhoneNumber"
                :required="phoneNumberReq"
                phoneNumber
                label="Telefono numeris"
                v-model="item.phone_number"
                :cMask="showSMSInfo ? 15 : 8"
                :validateKey="getKeyPhoneNumber"
                :key="getKeyPhoneNumber"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col class="py-0" cols="4" md="4">
          <el-checkbox
            style="margin-top: 3px"
            label="El. paštu"
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. El paštu"
            :tooltipIndexKey= item.amn_id
            v-model="item.email_enabled"
          >
          </el-checkbox>
        </v-col>
        <v-col class="py-0" cols="8" md="8">
          <el-text-field
            v-if="showEmailAddress"
             :required="emailAddressReq"
            email
            label="El. paštas"
            v-model="item.email_address"
            :validateKey="getKeyEmailAddress"
            :key="getKeyEmailAddress"
          />
        </v-col>
      </v-row>
      <!-- <template v-if="showChildren">
        <div v-for="(item, index) in item.jur_representers" :key="item.id">
          <contact-information-card :firstHeader="index == 0" :index="index" :item="item" />
        </div>
        <div class="pb-4"/>
      </template> -->

    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ContactInformationCard',
  props: {
    index: [String, Number],
    item: [Object, Boolean, String, Number],
    firstHeader: Boolean,
  },
  data() {
    return {}
  },
  created() {},
  computed: {
    showSMSInfo(){
      if(this.item.phone_number_prepend != '' && this.item.phone_number_prepend != '+370') {
        return this.$t('Informuojame, kad trumpieji pranešimai (SMS) siunčiami tik Lietuvoje veikiančių mobiliojo ryšio operatorių registruotiems telefono numeriams.')
      } else {
        return ''
      }
    },
    showChildren(){
      return this.item.jur_representers?.length > 0
    },
    getKeyPhoneNumber() {
      return `${this.getLabel}-phone-number-${this.index}`
    },
    getKeyEmailAddress() {
      return `${this.getLabel}-email-address-${this.index}`
    },
    showPhoneNumber() {
      // return this.item.sms_enabled
      return true
    },
    showEmailAddress() {
      // return this.item.email_enabled
      return true
    },
    phoneNumberReq() {
      return this.item.sms_enabled
    },
    emailAddressReq() {
      return this.item.email_enabled
    },
    getLabel() {
      let title = ''
      switch (this.item.role) {
        case 'principal':
          title = 'Įgaliotojas'
          break
        case 'representitive':
          title = 'Įgaliotinis'
          break
        case 'sub_representitive':
          title = 'Perįgaliotinis'
          break
        case 'jur-representer':
          title = 'Atstovas'
          break
        case 'payer':
          title = 'Mokėtojas'
          break
      }
      return this.$t(title)
    },
    elValue: {
      get() {
        return this.item
      },
      set(elValue) {
        this.$emit('item', elValue)
      },
    },
  },
  watch: {
    'item.phone_number_prepend'(newVal) {
      if(newVal === '' || newVal.charAt(0) != '+'){
        this.$nextTick(() => {
          this.$set(this.item, 'phone_number_prepend', '+')
        })
      }
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.info-sms-msg{
      color: #ff5252;
}
</style>
